export const manufacturerAreas = [
  {
    id: 'profile',
    titleKey: 'views.manufacturer.dashboard.cards.profile.title',
    descriptionKey: 'views.manufacturer.dashboard.cards.profile.description',
    statusKey: 'views.manufacturer.dashboard.status.available',
    to: '/manufacturer/profile',
    icon: 'mdi-account-cog-outline',
    disabled: false
  },
  {
    id: 'product',
    titleKey: 'views.manufacturer.dashboard.cards.product.title',
    descriptionKey: 'views.manufacturer.dashboard.cards.product.description',
    statusKey: 'views.manufacturer.dashboard.status.comingSoon',
    to: '/manufacturer/product-standardization',
    icon: 'mdi-clipboard-text-outline',
    disabled: true
  },
  {
    id: 'facility',
    titleKey: 'views.manufacturer.dashboard.cards.facility.title',
    descriptionKey: 'views.manufacturer.dashboard.cards.facility.description',
    statusKey: 'views.manufacturer.dashboard.status.available',
    to: '/manufacturer/facility-prequalification',
    icon: 'mdi-factory',
    disabled: false
  },
  {
    id: 'budget',
    titleKey: 'views.manufacturer.dashboard.cards.budget.title',
    descriptionKey: 'views.manufacturer.dashboard.cards.budget.description',
    statusKey: 'views.manufacturer.dashboard.status.comingSoon',
    to: '/manufacturer/budget',
    icon: 'mdi-cash-check',
    disabled: true
  }
];
